const HISTORY_PREFIX = 'xph_upgrade_nudge_history_';
const LOGIN_PREFIX = 'xph_upgrade_nudge_login_';
const SLOTS_PREFIX = 'xph_upgrade_nudge_slots_';

export const UPGRADE_NUDGE_WINDOW_MS = 24 * 60 * 60 * 1000;
export const UPGRADE_NUDGE_MAX_PER_WINDOW = 3;
export const UPGRADE_NUDGE_DELAYS_MS = [
  5 * 60 * 1000,
  60 * 60 * 1000,
  3 * 60 * 60 * 1000,
];

const historyKey = (userId) => `${HISTORY_PREFIX}${userId}`;
const loginKey = (userId) => `${LOGIN_PREFIX}${userId}`;
const slotsKey = (userId) => `${SLOTS_PREFIX}${userId}`;

function readJson(storage, key, fallback) {
  try {
    const raw = storage.getItem(key);
    if (!raw) return fallback;
    return JSON.parse(raw);
  } catch {
    return fallback;
  }
}

function writeJson(storage, key, value) {
  try {
    storage.setItem(key, JSON.stringify(value));
  } catch {
    /* quota / private mode */
  }
}

export function pruneUpgradeNudgeHistory(entries, now = Date.now()) {
  if (!Array.isArray(entries)) return [];
  return entries.filter((entry) => {
    const at = Number(entry?.at);
    return Number.isFinite(at) && now - at < UPGRADE_NUDGE_WINDOW_MS;
  });
}

export function getUpgradeNudgeHistory(userId) {
  if (!userId) return [];
  return pruneUpgradeNudgeHistory(readJson(window.localStorage, historyKey(userId), []));
}

export function recordUpgradeNudgeShown(userId, pitchId, slot) {
  if (!userId) return;
  const next = pruneUpgradeNudgeHistory(getUpgradeNudgeHistory(userId));
  next.push({ id: pitchId, slot, at: Date.now() });
  writeJson(window.localStorage, historyKey(userId), next);

  const slots = new Set(readJson(window.sessionStorage, slotsKey(userId), []));
  slots.add(slot);
  writeJson(window.sessionStorage, slotsKey(userId), [...slots]);
}

export function getShownSlotsThisLogin(userId) {
  if (!userId) return new Set();
  const slots = readJson(window.sessionStorage, slotsKey(userId), []);
  return new Set(Array.isArray(slots) ? slots : []);
}

export function ensureUpgradeNudgeLoginAt(userId) {
  if (!userId) return Date.now();
  const existing = Number(window.sessionStorage.getItem(loginKey(userId)));
  if (Number.isFinite(existing) && existing > 0) return existing;
  const now = Date.now();
  try {
    window.sessionStorage.setItem(loginKey(userId), String(now));
  } catch {
    /* ignore */
  }
  return now;
}

export function resetUpgradeNudgeSession(userId) {
  if (!userId) return;
  try {
    window.sessionStorage.removeItem(loginKey(userId));
    window.sessionStorage.removeItem(slotsKey(userId));
  } catch {
    /* ignore */
  }
}

export function pitchIdForSlot(slot, isVerifiedStudent) {
  if (isVerifiedStudent) return 'student';
  return ['team', 'okr', 'ai'][slot] || 'team';
}
